
<template>
  <footer
    id="portal-footer-wrapper"
    class="XXsnipcss_extracted_selector_selectionXX"
  >
    <div class="portal-footer">
      
      <!-- FOOTER RIGA VUOTA --> 
      <div
        class="portletWrapper"
      ></div>

      <!-- FOOTER RIGA 1 - 3 colonne: Agenzia, Redazione, Trasparenza --> 
      <div
        class="portletWrapper"
      >

        <section class="portlet rerPortletAdvancedStatic">
          <header class="portletHeader">
            <span class="headerImg" style="background-image:url()">
            </span>

            <h4 class="portlet-header">
              Contatti protezione civile
            </h4>

          </header>

          <section class="portletContent">
              <div class="colonna-1-di-3">
                <h3></h3>
                <h4>Agenzia per la sicurezza territoriale e la protezione civile</h4>
                <p>Viale Silvani 6,<br>40122 Bologna<br>centralino 051/5274404<br>E-mail:<a href="mailto:procivsegr@regione.emilia-romagna.it">procivsegr@regione.emilia-romagna.it</a></p>
                <h3>Seguici su</h3>
                <hr>
<ul class="footer-social">

<!-- NEWSLETTER -->
<li><a class="newsletter" href="https://protezionecivile.regione.emilia-romagna.it/newsletter" title="newsletter">
<svg class="svg-inline--fa fa-w-16"
 viewBox="0 0 281 281" version="1.1" xmlns="http://www.w3.org/2000/svg" >
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group" fill="#333333">
            <path d="M158.0625,140.928571 L158.0625,158.491071 L70.25,158.491071 L70.25,140.928571 L158.0625,140.928571 Z M245.875,140.928571 L245.875,158.491071 L175.625,158.491071 L175.625,140.928571 L245.875,140.928571 Z M245.875,105.803571 L245.875,123.366071 L175.625,123.366071 L175.625,105.803571 L245.875,105.803571 Z M245.875,70.6785714 L245.875,88.2410714 L175.625,88.2410714 L175.625,70.6785714 L245.875,70.6785714 Z M245.875,35.5535714 L245.875,53.1160714 L175.625,53.1160714 L175.625,35.5535714 L245.875,35.5535714 Z M35.125,167.272321 L35.125,35.5535714 L17.5625,35.5535714 L17.5625,167.272321 C17.5625,169.650589 18.4314692,171.708673 20.1694336,173.446638 C21.907398,175.184602 23.9654829,176.053571 26.34375,176.053571 C28.7220171,176.053571 30.780102,175.184602 32.5180664,173.446638 C34.2560308,171.708673 35.125,169.650589 35.125,167.272321 Z M263.4375,167.272321 L263.4375,17.9910714 L52.6875,17.9910714 L52.6875,167.272321 C52.6875,170.290891 52.1844126,173.217945 51.1782227,176.053571 L254.65625,176.053571 C257.034517,176.053571 259.092602,175.184602 260.830566,173.446638 C262.568531,171.708673 263.4375,169.650589 263.4375,167.272321 Z M281,0.428571429 L281,167.272321 C281,174.590066 278.438828,180.810056 273.316406,185.932478 C268.193985,191.054899 261.973995,193.616071 254.65625,193.616071 L26.34375,193.616071 C19.0260051,193.616071 12.8060152,191.054899 7.68359375,185.932478 C2.5611723,180.810056 0,174.590066 0,167.272321 L0,17.9910714 L35.125,17.9910714 L35.125,0.428571429 L281,0.428571429 Z" id="xxx"></path>
            <path d="M157,72.7463797 L157,73.5587417 C157,83.9841066 155.358368,91.6168485 152.075055,96.4571965 C148.791742,101.297544 143.900695,103.717682 137.401766,103.717682 C132.595267,103.717682 128.668889,102.499151 125.622517,100.062053 C124.945545,99.5204756 124.370127,98.843514 123.896247,98.0311479 C118.480473,101.82219 113.470958,103.717682 108.86755,103.717682 C102.504015,103.717682 97.7483601,101.737569 94.6004415,97.7772848 C91.4525229,93.8170001 89.8785872,87.419713 89.8785872,78.5852318 C89.8785872,69.7507505 91.3509787,63.2688433 94.2958057,59.1393157 C97.2406328,55.009788 102.233225,52.9450552 109.273731,52.9450552 C111.643132,52.9450552 114.215586,53.5543206 116.99117,54.7728698 L118.514349,55.4836865 L118.514349,54.1635982 L132.121413,54.1635982 L132.121413,72.3401987 C132.121413,81.6824087 132.307577,87.0304053 132.679912,88.3843488 C133.052246,89.7382923 133.458423,90.6860385 133.898455,91.2276159 C134.338486,91.7691933 134.795435,92.09075 135.269316,92.1922958 C135.743196,92.2938416 136.386309,92.3446137 137.198675,92.3446137 C139.364985,92.3446137 140.938921,91.0245386 141.92053,88.3843488 C142.902139,85.744159 143.392936,80.8023394 143.392936,73.5587417 L143.392936,72.6448344 C143.392936,61.8132865 140.905102,53.9436081 135.92936,49.0355629 C130.953618,44.1275178 123.033167,41.673532 112.16777,41.673532 C101.302374,41.673532 92.9926704,44.7875553 87.2384106,51.0156954 C81.4841508,57.2438354 78.607064,66.2981967 78.607064,78.1790508 C78.607064,90.0599049 81.1795181,98.8265575 86.3245033,104.479272 C91.4694886,110.131986 100.100749,112.9583 112.218543,112.9583 L126.739514,112.044393 L127.247241,123.925188 C121.154495,124.602159 116.144979,124.94064 112.218543,124.94064 C104.433368,124.94064 97.7314483,124.162134 92.1125828,122.605099 C86.4937173,121.048064 81.5857458,118.47561 77.388521,114.88766 C69.1294657,107.644062 65,95.0864249 65,77.2143709 C65,61.5763236 69.2310099,49.7464198 77.6931567,41.7243046 C86.1553035,33.7021895 97.7313467,29.6911921 112.421634,29.6911921 C127.11192,29.6911921 138.21409,33.3637087 145.728477,40.7088521 C153.242863,48.0539955 157,58.7330646 157,72.7463797 Z M109.984547,91.7353422 C112.55704,91.7353422 115.603367,90.8891402 119.12362,89.1967108 C118.717437,86.7596125 118.514349,83.1717161 118.514349,78.4329139 L118.514349,65.9428477 C115.671067,65.2658759 113.606335,64.9273951 112.320088,64.9273951 C108.799835,64.9273951 106.481242,65.9089894 105.364238,67.8722075 C104.247235,69.8354256 103.688742,73.2879297 103.688742,78.2298234 C103.688742,87.2335476 105.787323,91.7353422 109.984547,91.7353422 Z" id="@"></path>
        </g>
    </g>
</svg>
<span class="newsletter">Newsletter</span></a></li>

<!-- RSS -->
<li><a class="rss" href="https://protezionecivile.regione.emilia-romagna.it/rss-dal-portale" title="rss"
  ><svg class="svg-inline--fa fa-rss fa-w-16" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="rss" role="img" 
  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"></path></svg><!-- <i class="fas fa-rss"></i> --><span class="social">RSS</span></a></li>

<!-- FACEBOOK -->
<li>
  <a href="https://www.facebook.com/ERprotezionecivile" rel="noopener noreferrer" target="_blank" title="facebook" 
    class="fb">
    <svg  aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook-f" role="img" 
    xmlns="http://www.w3.org/2000/svg" 
    
    class="svg-inline--fa fa-facebook-f fa-w-16"
    viewBox="0 0 320 512" data-fa-i2svg="" ><path fill="currentColor" d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"></path></svg><span  class="social">Facebook</span></a>
</li>
</ul>

<i class="far fa-newspaper"></i>
              </div>

                <div class="colonna-1-di-3">
                <h3>Redazione</h3>
                <hr>
                <ul>
                <li><a href="https://protezionecivile.regione.emilia-romagna.it/info">Informazioni sul sito e crediti</a></li>
                <li><strong>Scrivici</strong>: <a href="mailto:procivcomunicazione@regione.emilia-romagna.it">e-mail</a></li>
                </ul>
              </div>
              <div class="colonna-1-di-3">
                <h3>Trasparenza</h3>
                <hr>
                <ul>
                <li><a href="https://protezionecivile.regione.emilia-romagna.it/trasparenza">Amministrazione trasparente</a></li>
                <li><a href="https://trasparenza.regione.emilia-romagna.it/altri-contenuti/anticorruzione/segnala-irregolarita-o-illeciti">Segnala illeciti o irregolarità</a></li>
                <li><a href="https://protezionecivile.regione.emilia-romagna.it/note-legali">Note legali e copyright</a></li>
                <li><a href="https://protezionecivile.regione.emilia-romagna.it/privacy/privacy">Privacy e Cookies</a></li>
                <li><a href="https://protezionecivile.regione.emilia-romagna.it/accessibilita">Dichiarazione di accessibilità</a></li>
                </ul>
                </div>
          </section>
          
      </section>
      
      </div>

      <!-- FOOTER RIGA 2 - 1 colonna: codice fiscale protezione civile -->
      <div
        class="portletWrapper"
      >
        <section class="portlet rerPortletAdvancedStatic footer-actions">
          <header class="portletHeader">
            <span class="headerImg" style="background-image:url()">
            </span>

            <h4 class="portlet-header">
              Colophon Protezione Civile
            </h4>

          </header>
          <section class="portletContent">
              <div class="tinyAlignCenter">C.F. 91278030373</div>
          </section>          
        </section>
      </div>

      <!-- FOOTER RIGA 3 - 1 colonna LOGO ER  -->
      <div
        class="portletWrapper"
      >
        <section class="portlet rerPortletAdvancedStatic footer-actions">
          <header class="portletHeader">
            <span class="headerImg" style="background-image:url()">
            </span>

            <h4 class="portlet-header">
              Logo RER
            </h4>

          </header>

          <section class="portletContent">
              <hr>
          <p><img alt="Regione Emilia-Romagna" class="image-inline" src="https://protezionecivile.regione.emilia-romagna.it/impostazioni/immagini/logo-regione.png/@@images/f4324da7-afc9-4920-bc16-a7af1520d5d8.png" title="Logo Regione Emilia-Romagna"></p>
          </section>
        </section>
      
      </div>

      <!-- FOOTER RIGA 4 - 2 colonne: Recapiti e URP -->
      <div
        class="portletWrapper"
      >
      <section class="portlet rerPortletAdvancedStatic">
        <header class="portletHeader">
          <span class="headerImg" style="background-image:url()">
          </span>

          <h4 class="portlet-header">
            Contatti rer
          </h4>

        </header>

      <section class="portletContent">
          <div class="colonna-1-di-2">
        <h3>Recapiti</h3>
        <p><strong>Regione Emilia-Romagna</strong><br>
        Viale Aldo Moro, 52<strong><br></strong>
        40127 Bologna<br>
        <strong>Centralino</strong> <a href="tel:+39.0515271">051 5271</a><br>
        <a class="external-link" href="http://wwwservizi.regione.emilia-romagna.it/Cercaregione/Default.aspx?cons=0">Cerca telefoni o indirizzi</a></p>
        </div>
        <div class="colonna-1-di-2">
        <h3><acronym title="Ufficio relazioni con il pubblico">URP</acronym></h3>
        <p><strong>Sito web</strong>: <a href="http://www.regione.emilia-romagna.it/urp">www.regione.emilia-romagna.it/urp</a><br>
        <strong>Numero verde: </strong><a href="tel:+39.800662200">800.66.22.00</a><br>
        <strong>Scrivici</strong>: <a href="mailto:urp@regione.emilia-romagna.it">e-mail</a> - <a href="mailto:urp@postacert.regione.emilia-romagna.it">PEC</a>
        <br></p>
        </div>
            </section>

            
        </section>
      </div>

      <!-- FOOTER RIGA 5 - 1 colonna: Codice Fiscale RER -->
      <div
        class="portletWrapper"
      >
        <section class="portlet rerPortletAdvancedStatic footer-actions">
          <header class="portletHeader">
            <span class="headerImg" style="background-image: url()"> </span>
            <h4 class="portlet-header">Colophon</h4>
          </header>
          <section class="portletContent">
            <div class="tinyAlignCenter">C.F. 800.625.903.79</div>
          </section>
        </section>
      </div>

    </div>

    <!-- numero di versione -->
    <div style="text-align: right; margin-right: 10px">v1.0.1</div>

  </footer>
</template>

<script>
export default {
  name: "footer-emilia",
  data() {
    return {};
  },
  methods: {
    goBack() {
      this.$store.commit("setCurrentFire", null);
      this.$router.push({
        path: "/",
      });
    },
    onSelect(fire) {
      this.$store.commit("setCurrentFire", fire);
      this.$router.push({
        path: "/",
      });
    },
  },
  computed: {
    fires() {
      // console.log("this.$store.getters.fires: " + this.$store.getters.fires);
      return this.$store.getters.fires;
    },
  },
  mounted() {
    /*console.log(
      "this.$store.getters.fires fireslist: " +
        JSON.stringify(this.$store.getters.fires)
    );*/
  },
  created() {},
};
</script>

<style scoped lang="scss">
// @font-face {
//   font-family: "ita";
//   font-style: normal;
//   font-weight: normal;
//   src: url("https://www.regione.emilia-romagna.it/++theme++rer.agidtheme.base/css/++theme++design.plone.theme/font/fonts/ita.eot?v2");
//   src: url("https://www.regione.emilia-romagna.it/++theme++rer.agidtheme.base/css/++theme++design.plone.theme/font/fonts/ita.eot?v2#iefix")
//       format("embedded-opentype"),
//     url("https://www.regione.emilia-romagna.it/++theme++rer.agidtheme.base/css/++theme++design.plone.theme/font/fonts/ita.ttf?v2")
//       format("truetype"),
//     url("https://www.regione.emilia-romagna.it/++theme++rer.agidtheme.base/css/++theme++design.plone.theme/font/fonts/ita.woff?v2")
//       format("woff"),
//     url("https://www.regione.emilia-romagna.it/++theme++rer.agidtheme.base/css/++theme++design.plone.theme/font/fonts/ita.svg?v2#ita")
//       format("svg");
// }
// @font-face {
//   font-family: "ita";
//   font-style: normal;
//   font-weight: normal;
//   src: url("https://www.regione.emilia-romagna.it/++theme++rer.agidtheme.base/css/++theme++design.plone.theme/font/fonts/ita.eot?v2");
//   src: url("https://www.regione.emilia-romagna.it/++theme++rer.agidtheme.base/css/++theme++design.plone.theme/font/fonts/ita.eot?v2#iefix")
//       format("embedded-opentype"),
//     url("https://www.regione.emilia-romagna.it/++theme++rer.agidtheme.base/css/++theme++design.plone.theme/font/fonts/ita.ttf?v2")
//       format("truetype"),
//     url("https://www.regione.emilia-romagna.it/++theme++rer.agidtheme.base/css/++theme++design.plone.theme/font/fonts/ita.woff?v2")
//       format("woff"),
//     url("https://www.regione.emilia-romagna.it/++theme++rer.agidtheme.base/css/++theme++design.plone.theme/font/fonts/ita.svg?v2#ita")
//       format("svg");
// }
@font-face {
  font-family: "Titillium Web";
  font-style: normal;
  font-weight: 300;
  src: url(https://fonts.gstatic.com/s/titilliumweb/v9/NaPDcZTIAOhVxoMyOr9n_E7ffGjEGIVzY4SY.woff2)
    format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
@font-face {
  font-family: "Titillium Web";
  font-style: normal;
  font-weight: 300;
  src: url(https://fonts.gstatic.com/s/titilliumweb/v9/NaPDcZTIAOhVxoMyOr9n_E7ffGjEGItzYw.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}
@font-face {
  font-family: "Titillium Web";
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/titilliumweb/v9/NaPecZTIAOhVxoMyOr9n_E7fdM3mDbRS.woff2)
    format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
@font-face {
  font-family: "Titillium Web";
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/titilliumweb/v9/NaPecZTIAOhVxoMyOr9n_E7fdMPmDQ.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}
@font-face {
  font-family: "Titillium Web";
  font-style: normal;
  font-weight: 600;
  src: url(https://fonts.gstatic.com/s/titilliumweb/v9/NaPDcZTIAOhVxoMyOr9n_E7ffBzCGIVzY4SY.woff2)
    format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
@font-face {
  font-family: "Titillium Web";
  font-style: normal;
  font-weight: 600;
  src: url(https://fonts.gstatic.com/s/titilliumweb/v9/NaPDcZTIAOhVxoMyOr9n_E7ffBzCGItzYw.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}
* {
  box-sizing: border-box;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}

.section-homepage #portal-top {
  background: #fff;
  background-image: initial;
  background-position-x: initial;
  background-position-y: initial;
  background-size: initial;
  background-repeat-x: initial;
  background-repeat-y: initial;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  background-color: rgb(255, 255, 255);
}

body.template-homepage_view #portal-top {
  background: #fff;
  background-image: initial;
  background-position-x: initial;
  background-position-y: initial;
  background-size: initial;
  background-repeat-x: initial;
  background-repeat-y: initial;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  background-color: rgb(255, 255, 255);
}

body {
  margin: 0;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
}

body {
  font-family: "Titillium Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 18px;
  line-height: 1.5;
  color: #1c2024;
  background-color: #fff;
}

html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

html {
  font-size: 10px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

#header-banner,
#portal-header {
  z-index: 300;
  position: relative;
}

#portal-header {
  padding: 1.8rem 0;
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 1.8rem;
  padding-bottom: 1.8rem;
}

@media (min-width: 768px) {
  #portal-header {
    max-width: auto;
  }
}

@media (min-width: 992px) {
  #portal-header {
    max-width: auto;
  }
}

@media (min-width: 1200px) {
  #portal-header {
    max-width: 1170px;
  }
}

#portal-top #portal-header {
  margin-top: 0;
  margin-bottom: 0;
}

:before,
:after {
  box-sizing: border-box;
}

#portal-header:before,
#portal-header:after {
  content: " ";
  display: table;
}

#portal-header:after {
  clear: both;
}

a {
  background-color: transparent;
}

a {
  color: #cb1d15;
  text-decoration: none;
  text-decoration-line: none;
  text-decoration-thickness: initial;
  text-decoration-style: initial;
  text-decoration-color: initial;
}

#portal-logo {
  margin: 0 auto 0 0;
  color: #1c2024;
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-top: 0px;
  margin-right: auto;
  margin-bottom: 0px;
  margin-left: 0px;
  flex-direction: row;
  flex-wrap: nowrap;
}

img {
  border: 0;
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-top-style: initial;
  border-right-style: initial;
  border-bottom-style: initial;
  border-left-style: initial;
  border-top-color: initial;
  border-right-color: initial;
  border-bottom-color: initial;
  border-left-color: initial;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
}

img {
  vertical-align: middle;
}

#portal-logo img {
  margin-right: 2rem;
  height: 100%;
}

#portal-logo span {
  border-bottom: 3px solid rgba(0, 0, 0, 0);
  font-size: 3.4rem;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
  border-bottom-width: 3px;
  border-bottom-style: solid;
  border-bottom-color: rgba(0, 0, 0, 0);
}

#header-social {
  text-align: right;
}

#portal-searchbox {
  text-align: right;
}

#portal-searchbox {
  margin: 0;
  float: none;
  max-width: none;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
}

button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
  font-style: inherit;
  font-variant-ligatures: inherit;
  font-variant-caps: inherit;
  font-variant-numeric: inherit;
  font-variant-east-asian: inherit;
  font-weight: inherit;
  font-stretch: inherit;
  font-size: inherit;
  line-height: inherit;
  font-family: inherit;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
}

button {
  overflow: visible;
  overflow-x: visible;
  overflow-y: visible;
}

button,
select {
  text-transform: none;
}

button,
input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
  appearance: button;
}

input,
button,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.standalone,
.context,
.destructive,
[type="submit"],
button {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 600;
  text-align: center;
  text-shadow: 0 1px rgba(0, 0, 0, 0.25);
  vertical-align: middle;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  padding: 6px 12px;
  font-size: inherit;
  line-height: inherit;
  border-radius: 2px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-top-style: solid;
  border-right-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  padding-top: 6px;
  padding-right: 12px;
  padding-bottom: 6px;
  padding-left: 12px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
}

.standalone,
[type="submit"],
button {
  color: #4d4d4d;
  background-color: #e5e5e5;
  border-color: #b2b2b2;
  border-top-color: rgb(178, 178, 178);
  border-right-color: rgb(178, 178, 178);
  border-bottom-color: rgb(178, 178, 178);
  border-left-color: rgb(178, 178, 178);
}

button#search-toggle,
button.plone-navbar-toggle {
  display: none;
}

.plone-navbar-header {
  padding: 0;
  padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}

p {
  margin: 0 0 13.5px;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 13.5px;
  margin-left: 0px;
}

#header-social p {
  display: inline-block;
  margin: 0;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
}

ul,
ol {
  margin-top: 0;
  margin-bottom: 13.5px;
}

ul {
  list-style-image: url("https://www.regione.emilia-romagna.it/++theme++rer.agidtheme.base/css/++theme++rer.agidtheme.base/images/chevron-right.png");
  padding-left: 20px;
}

.list-inline,
#header-social ul,
#portal-mainnavigation ul#portal-globalnav,
#portal-breadcrumbs ol,
#portal-footer-wrapper ul.footer-social,
ul,
ul {
  padding-left: 0;
  list-style: none;
  margin-left: -5px;
  list-style-position: initial;
  list-style-image: initial;
  list-style-type: none;
}

#header-social ul {
  display: inline-block;
  padding-left: 1rem;
}

.svg-inline--fa {
  display: inline-block;
  font-size: inherit;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
  overflow-x: visible;
  overflow-y: visible;
}

svg:not(:root) {
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
}

.svg-inline--fa.fa-w-16 {
  width: 1em;
}

svg:not(:root).svg-inline--fa {
  overflow: visible;
  overflow-x: visible;
  overflow-y: visible;
}

.fa-search:before {
  content: "\f002";
}

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-top-style: initial;
  border-right-style: initial;
  border-bottom-style: initial;
  border-left-style: initial;
  border-top-color: initial;
  border-right-color: initial;
  border-bottom-color: initial;
  border-left-color: initial;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  margin-top: -1px;
  margin-right: -1px;
  margin-bottom: -1px;
  margin-left: -1px;
  overflow-x: hidden;
  overflow-y: hidden;
  padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}

.sr-only,
.hiddenStructure,
#header-social ul li a span,
li a span,
nav.pagination ul li .label {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  margin-top: -1px;
  margin-right: -1px;
  margin-bottom: -1px;
  margin-left: -1px;
  padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  overflow-x: hidden;
  overflow-y: hidden;
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-top-style: initial;
  border-right-style: initial;
  border-bottom-style: initial;
  border-left-style: initial;
  border-top-color: initial;
  border-right-color: initial;
  border-bottom-color: initial;
  border-left-color: initial;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  margin-top: -1px;
  margin-right: -1px;
  margin-bottom: -1px;
  margin-left: -1px;
  overflow-x: hidden;
  overflow-y: hidden;
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-top-style: initial;
  border-right-style: initial;
  border-bottom-style: initial;
  border-left-style: initial;
  border-top-color: initial;
  border-right-color: initial;
  border-bottom-color: initial;
  border-left-color: initial;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
}

button#search-toggle .sr-only,
.hiddenStructure,
#header-social ul li a span,
button#search-toggle span,
li a span,
button#search-toggle span,
#portal-header button#search-toggle nav.pagination ul li .label,
nav.pagination ul li #portal-header button#search-toggle .label,
button.plone-navbar-toggle .sr-only,
.hiddenStructure,
#header-social ul li a span,
button.plone-navbar-toggle span,
li a span,
button.plone-navbar-toggle span,
#portal-header button.plone-navbar-toggle nav.pagination ul li .label,
nav.pagination ul li #portal-header button.plone-navbar-toggle .label {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  margin-top: -1px;
  margin-right: -1px;
  margin-bottom: -1px;
  margin-left: -1px;
  padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  overflow-x: hidden;
  overflow-y: hidden;
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-top-style: initial;
  border-right-style: initial;
  border-bottom-style: initial;
  border-left-style: initial;
  border-top-color: initial;
  border-right-color: initial;
  border-bottom-color: initial;
  border-left-color: initial;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
}

.plone-navbar-header .plone-navbar-toggle {
  display: none;
  background-color: transparent;
  border: 0 none;
  padding: 0;
  margin: 10px 0;
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-top-style: none;
  border-right-style: none;
  border-bottom-style: none;
  border-left-style: none;
  border-top-color: initial;
  border-right-color: initial;
  border-bottom-color: initial;
  border-left-color: initial;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  margin-top: 10px;
  margin-right: 0px;
  margin-bottom: 10px;
  margin-left: 0px;
}

button.plone-navbar-toggle {
  height: 100%;
  width: 100%;
  margin: 0;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
}

button.plone-navbar-toggle:before {
  display: none;
}

li,
#header-social ul > li,
li,
li,
li,
ul > li,
ul > li {
  display: inline-block;
  padding-left: 5px;
  padding-right: 5px;
}

#header-social ul li {
  padding-right: 0;
}

.svg-inline--fa.fa-w-14 {
  width: 0.875em;
}

button.plone-navbar-toggle svg {
  display: inline-block;
}

.fa-navicon:before,
.fa-reorder:before,
.fa-bars:before {
  content: "\f0c9";
}

#header-social ul li a {
  display: inline-block;
  border-radius: 100%;
  background-color: #cb1d15;
  color: #fff;
  width: 3rem;
  height: 3rem;
  text-align: center;
  font-size: 2rem;
  line-height: 30px;
  vertical-align: middle;
  border-top-left-radius: 100%;
  border-top-right-radius: 100%;
  border-bottom-right-radius: 100%;
  border-bottom-left-radius: 100%;
}

.svg-inline--fa.fa-w-10 {
  width: 0.625em;
}

.fa-facebook-f:before,
.fa-facebook:before {
  content: "\f09a";
}

.fa-instagram:before {
  content: "\f16d";
}

.fa-twitter:before {
  content: "\f099";
}

.svg-inline--fa.fa-w-18 {
  width: 1.125em;
}

.fa-youtube:before {
  content: "\f167";
}

label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: bold;
}

input {
  line-height: normal;
}

input[type="text"],
input[type="number"],
input[type="email"],
input[type="password"],
textarea,
select {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #cccccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  padding-top: 6px;
  padding-right: 12px;
  padding-bottom: 6px;
  padding-left: 12px;
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-top-style: solid;
  border-right-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-top-color: rgb(204, 204, 204);
  border-right-color: rgb(204, 204, 204);
  border-bottom-color: rgb(204, 204, 204);
  border-left-color: rgb(204, 204, 204);
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  transition-duration: 0.15s, 0.15s;
  transition-timing-function: ease-in-out, ease-in-out;
  transition-delay: 0s, 0s;
  transition-property: border-color, box-shadow;
}

input[type="text"],
input[type="number"],
input[type="email"],
input[type="password"],
textarea,
select {
  font-size: inherit;
}

#portal-searchbox #searchGadget {
  border: 1px solid #cb1d15;
  padding: 1.1rem 1.4rem;
  width: 25rem;
  border-radius: 0;
  box-shadow: none;
  float: left;
  height: 50px;
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-top-style: solid;
  border-right-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-top-color: rgb(203, 29, 21);
  border-right-color: rgb(203, 29, 21);
  border-bottom-color: rgb(203, 29, 21);
  border-left-color: rgb(203, 29, 21);
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  padding-top: 1.1rem;
  padding-right: 1.4rem;
  padding-bottom: 1.1rem;
  padding-left: 1.4rem;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

#portal-searchbox #searchGadget {
  border-radius: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  height: inherit;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

#portal-searchbox button.search-button {
  color: #fff;
  background-color: #cb1d15;
  text-align: center;
  width: 5rem;
  line-height: 1;
  border: 0;
  margin-left: -0.5rem;
  border-radius: 0;
  font-weight: 400;
  vertical-align: baseline;
  height: 50px;
  font-size: 2.6rem;
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-top-style: initial;
  border-right-style: initial;
  border-bottom-style: initial;
  border-left-style: initial;
  border-top-color: initial;
  border-right-color: initial;
  border-bottom-color: initial;
  border-left-color: initial;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.section-homepage #portal-top {
  background: #fff;
  background-image: initial;
  background-position-x: initial;
  background-position-y: initial;
  background-size: initial;
  background-repeat-x: initial;
  background-repeat-y: initial;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  background-color: rgb(255, 255, 255);
}

body.template-homepage_view #portal-top {
  background: #fff;
  background-image: initial;
  background-position-x: initial;
  background-position-y: initial;
  background-size: initial;
  background-repeat-x: initial;
  background-repeat-y: initial;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  background-color: rgb(255, 255, 255);
}

.skip-link-wrapper {
  position: absolute;
  top: -100%;
}

#header-banner {
  background-color: #303030;
  color: #fff;
  font-weight: 600;
  padding: 1.3rem 0;
  z-index: 500;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding-top: 1.3rem;
  padding-right: 0px;
  padding-bottom: 1.3rem;
  padding-left: 0px;
}

#header-banner:not(.orma-banner) {
  background-color: #eee;
  color: #000;
}

#portal-header {
  margin-top: 0;
  margin-bottom: 0;
}

.skip-link-wrapper a.skip-link {
  color: #9d1610;
}

#header-banner .header-banner-inner {
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
}

@media (min-width: 768px) {
  #header-banner .header-banner-inner {
    max-width: auto;
  }
}

@media (min-width: 992px) {
  #header-banner .header-banner-inner {
    max-width: auto;
  }
}

@media (min-width: 1200px) {
  #header-banner .header-banner-inner {
    max-width: 1170px;
  }
}

#header-banner .header-banner-inner:before,
#header-banner .header-banner-inner:after {
  content: " ";
  display: table;
}

#header-banner .header-banner-inner:after {
  clear: both;
}

#header-banner .header-banner-second-link,
#header-banner .header-banner-language,
#header-banner .header-banner-login-button {
  margin-left: 2rem;
}

#header-banner .header-banner-second-link {
  text-align: right;
}

#portal-header button#search-toggle,
#portal-header button.plone-navbar-toggle {
  display: none;
}

a,
#header-banner .header-banner-second-link a {
  color: #fff;
}

#header-banner:not(.orma-banner) a,
a,
#header-banner:not(.orma-banner) .header-banner-second-link a,
a {
  color: #000;
}

#portal-header button#search-toggle .sr-only,
.hiddenStructure,
#header-social ul li a span,
#portal-header button#search-toggle span,
li a span,
#portal-header button#search-toggle span,
#portal-header button#search-toggle nav.pagination ul li .label,
nav.pagination ul li #portal-header button#search-toggle .label,
#portal-header button.plone-navbar-toggle .sr-only,
.hiddenStructure,
#header-social ul li a span,
#portal-header button.plone-navbar-toggle span,
li a span,
#portal-header button.plone-navbar-toggle span,
#portal-header button.plone-navbar-toggle nav.pagination ul li .label,
nav.pagination ul li #portal-header button.plone-navbar-toggle .label {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  margin-top: -1px;
  margin-right: -1px;
  margin-bottom: -1px;
  margin-left: -1px;
  padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  overflow-x: hidden;
  overflow-y: hidden;
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-top-style: initial;
  border-right-style: initial;
  border-bottom-style: initial;
  border-left-style: initial;
  border-top-color: initial;
  border-right-color: initial;
  border-bottom-color: initial;
  border-left-color: initial;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
}

#portal-header button.plone-navbar-toggle {
  height: 100%;
  width: 100%;
  margin: 0;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
}

#portal-header button.plone-navbar-toggle:before {
  display: none;
}

#portal-header button.plone-navbar-toggle svg {
  display: inline-block;
}

a:active,
a:hover {
  outline: 0;
  outline-color: initial;
  outline-style: initial;
  outline-width: 0px;
}

a:hover,
a:focus {
  color: #9d1610;
  text-decoration: none;
  text-decoration-line: none;
  text-decoration-thickness: initial;
  text-decoration-style: initial;
  text-decoration-color: initial;
}

#portal-top #portal-header {
  margin-top: 0;
  margin-bottom: 0;
}

#portal-logo:hover span,
#portal-logo:focus span {
  border-bottom-color: #1c2024;
}

#portal-footer-wrapper {
  background-color: #30373d;
  padding: 50px 0px;
  color: #fff;
  padding-top: 50px;
  padding-right: 0px;
  padding-bottom: 50px;
  padding-left: 0px;
}

.portal-footer {
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
  padding-left: 0;
  padding-right: 0;
}

.portal-footer:before,
.portal-footer:after {
  content: " ";
  display: table;
}

.portal-footer:after {
  clear: both;
}

.portlet {
  margin-bottom: 1.5rem;
}

.portlet {
  border: inherit;
  margin-bottom: inherit;
  border-radius: inherit;
  box-shadow: none;
  border-top-color: inherit;
  border-top-style: inherit;
  border-top-width: inherit;
  border-right-color: inherit;
  border-right-style: inherit;
  border-right-width: inherit;
  border-bottom-color: inherit;
  border-bottom-style: inherit;
  border-bottom-width: inherit;
  border-left-color: inherit;
  border-left-style: inherit;
  border-left-width: inherit;
  border-image-source: inherit;
  border-image-slice: inherit;
  border-image-width: inherit;
  border-image-outset: inherit;
  border-image-repeat: inherit;
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

#portal-footer-wrapper .footer-logo,
.footer-actions {
  display: block;
  width: 100%;
  clear: both;
}

.footer-actions {
  padding: 5px 15px 0;
  padding-top: 5px;
  padding-right: 15px;
  padding-bottom: 0px;
  padding-left: 15px;
}

.portletHeader {
  border-bottom: 4px solid #4a4a4a;
  font-size: 2.1rem;
  font-weight: 600;
  padding: 0.8rem 0.3rem;
  margin-bottom: 0.5em;
  border-bottom-width: 4px;
  border-bottom-style: solid;
  border-bottom-color: rgb(74, 74, 74);
  padding-top: 0.8rem;
  padding-right: 0.3rem;
  padding-bottom: 0.8rem;
  padding-left: 0.3rem;
}

.portlet .portletHeader {
  background: inherit;
  font-weight: 600;
  font-size: 2.1rem;
  padding: inherit;
  color: inherit;
  background-image: inherit;
  background-position-x: inherit;
  background-position-y: inherit;
  background-size: inherit;
  background-repeat-x: inherit;
  background-repeat-y: inherit;
  background-attachment: inherit;
  background-origin: inherit;
  background-clip: inherit;
  background-color: inherit;
  padding-top: inherit;
  padding-right: inherit;
  padding-bottom: inherit;
  padding-left: inherit;
}

.portlet > :first-child {
  border-radius: 0;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.portletHeader {
  display: none;
}

.portlet .portletContent {
  font-size: inherit;
  border-top: inherit;
  background: inherit;
  font-weight: inherit;
  border-top-width: inherit;
  border-top-style: inherit;
  border-top-color: inherit;
  background-image: inherit;
  background-position-x: inherit;
  background-position-y: inherit;
  background-size: inherit;
  background-repeat-x: inherit;
  background-repeat-y: inherit;
  background-attachment: inherit;
  background-origin: inherit;
  background-clip: inherit;
  background-color: inherit;
}

.portlet > :last-child {
  border-radius: 0;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: inherit;
  font-weight: 600;
  line-height: 1.3;
  color: inherit;
}

h4,
.h4,
h5,
.h5,
h6,
.h6 {
  margin-top: 13.5px;
  margin-bottom: 13.5px;
}

h4,
.h4 {
  font-size: 20px;
}

.rerPortletAdvancedStatic .portletHeader h4.portlet-header {
  margin: 0;
  font-size: 1em;
  line-height: 1em;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
}

.colonna-1-di-2,
.tilesList .tileWrapper.colonna-1-di-2-sx,
.tilesList .tileWrapper.colonna-1-di-2-dx {
  width: 100%;
  position: relative;
  min-height: 1px;
  padding-left: 15px;
  padding-right: 15px;
}

.colonna-1-di-3 {
    width: 100%;
    position: relative;
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px;
}

.colonna-1-di-4 {
  width: 100%;
  position: relative;
  min-height: 1px;
  padding-left: 15px;
  padding-right: 15px;
}

hr {
  box-sizing: content-box;
  height: 0;
}

hr {
  margin-top: 27px;
  margin-bottom: 27px;
  border: 0;
  border-top: 1px solid #ccc;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-right-style: initial;
  border-bottom-style: initial;
  border-left-style: initial;
  border-right-color: initial;
  border-bottom-color: initial;
  border-left-color: initial;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: rgb(204, 204, 204);
}

hr {
  clear: both;
}

hr {
  border-color: #979797;
  margin-left: 0;
  width: 100%;
  max-width: 300px;
  border-top-color: rgb(151, 151, 151);
  border-right-color: rgb(151, 151, 151);
  border-bottom-color: rgb(151, 151, 151);
  border-left-color: rgb(151, 151, 151);
}

.footer-actions hr {
  max-width: 100%;
}

.tinyAlignCenter {
  text-align: center;
}

ul {
  list-style: none;
  padding-left: 0;
  list-style-position: initial;
  list-style-image: initial;
  list-style-type: none;
}

.list-inline,
ul,
#portal-mainnavigation ul#portal-globalnav,
#portal-breadcrumbs ol,
ul.footer-social,
ul,
ul {
  padding-left: 0;
  list-style: none;
  margin-left: -5px;
  list-style-position: initial;
  list-style-image: initial;
  list-style-type: none;
}

ul.footer-social {
  display: inline-block;
}

h1,
.h1,
h2,
.h2,
h3,
.h3 {
  margin-top: 27px;
  margin-bottom: 13.5px;
}

h3,
.h3 {
  font-size: 24px;
}

.image-inline {
  float: none;
}

img {
  max-width: 100%;
}

ul li {
  padding-bottom: 5px;
}

li,
ul > li,
li,
li,
ul.footer-social > li,
ul > li,
ul > li {
  display: inline-block;
  padding-left: 5px;
  padding-right: 5px;
}

footer ul > li {
  display: block;
}

ul.footer-social li {
  float: left;
}

ul li:before {
  padding-right: 15px;
  display: inline-block;
  font-family: ita;
  content: "⏵";
  color: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 0.6em;
}

ul.footer-social li:before {
  display: none;
}

b,
strong {
  font-weight: bold;
}

.portletContent a {
  border-bottom: 1px solid transparent;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: transparent;
}

a {
  color: #65dde0;
  text-decoration: underline;
  text-decoration-line: underline;
  text-decoration-thickness: initial;
  text-decoration-style: initial;
  text-decoration-color: initial;
}

ul.footer-social li a {
  display: inline-block;
}

i:before,
ul.footer-social li a:before,
ul.footer-social li a svg {
  display: inline-block;
  border-radius: 100%;
  background-color: #65dde0;
  width: 3rem;
  text-align: center;
  font-size: 2rem;
  line-height: 3rem;
  color: #30373d;
  border-top-left-radius: 100%;
  border-top-right-radius: 100%;
  border-bottom-right-radius: 100%;
  border-bottom-left-radius: 100%;
}

ul.footer-social li a:before {
  color: #fff;
}

ul.footer-social li a svg {
  padding: 0.4rem;
}

.sr-only,
.hiddenStructure,
ul li a span,
ul.footer-social li a span,
nav.pagination ul li .label {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  margin-top: -1px;
  margin-right: -1px;
  margin-bottom: -1px;
  margin-left: -1px;
  padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  overflow-x: hidden;
  overflow-y: hidden;
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-top-style: initial;
  border-right-style: initial;
  border-bottom-style: initial;
  border-left-style: initial;
  border-top-color: initial;
  border-right-color: initial;
  border-bottom-color: initial;
  border-left-color: initial;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
}

.fa-feed:before,
.fa-rss:before {
  content: "\f09e";
}

#portal-footer-wrapper .portal-footer {
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
  padding-left: 0;
  padding-right: 0;
}

@media (max-width: 992px) {
  ul.vertical > li {
    width: 100%;
  }
}

@media (min-width: 768px) {
  #portal-footer-wrapper .portal-footer {
    max-width: auto;
  }
}

@media (min-width: 992px) {
  #portal-footer-wrapper .portal-footer {
    max-width: auto;
  }
}

@media (min-width: 1200px) {
  #portal-footer-wrapper .portal-footer {
    max-width: 1170px;
  }
}

@media (min-width: 768px) {
  .portal-footer {
    max-width: auto;
  }
}

@media (min-width: 992px) {
  .portal-footer {
    max-width: auto;
  }
}

@media (min-width: 1200px) {
  .portal-footer {
    max-width: 1170px;
  }
}

@media (min-width: 768px) {
  .colonna-1-di-2,
  .tilesList .tileWrapper.colonna-1-di-2-sx,
  .tilesList .tileWrapper.colonna-1-di-2-dx {
    float: left;
    width: 100%;
  }
}

@media (min-width: 768px) {
  .colonna-1-di-3 {
      float: left;
      width: 33.3333333333%;
  }
}

@media (min-width: 992px) {
  .colonna-1-di-3 {
      float: left;
      width: 33.3333333333%;
  }
}

@media (min-width: 992px) {
  .colonna-1-di-2,
  .tilesList .tileWrapper.colonna-1-di-2-sx,
  .tilesList .tileWrapper.colonna-1-di-2-dx {
    float: left;
    width: 50%;
  }
}

@media (min-width: 768px) {
  .colonna-1-di-4 {
    float: left;
    width: 50%;
  }
}

@media (min-width: 992px) {
  .colonna-1-di-4 {
    float: left;
    width: 25%;
  }
}

#portal-footer-wrapper a {
  color: #65dde0 !important;
  text-decoration: underline;
}
</style>